import "@/utils/jquerySelect2";
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { initPwa } from "./utils/pwa.js";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";

initPwa();

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.config.globalProperties.$isDemo = process.env.VUE_APP_IS_DEMO || 0;
appInstance.mount("#app");
